import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import Loader from '@/components/common/Loader';
import LoaderSizes from '@/constants/ui/LoaderSizes';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import translate from '@/lib/intl/translate';
import { DonorRelationType, DonorType } from '@/propTypes';

function MakeConnectionPrimaryContactButton({ className, parent, relation }) {
  const [isLoading, setIsLoading] = React.useState(false);
  const { updateRelationship } = useConstituent(parent.constituentId);

  const isPrimaryContact = !!relation.relationData?.primaryContact;

  const icon = isPrimaryContact ? <StarIcon /> : <StarBorderIcon />;

  const label = isPrimaryContact
    ? translate('RELATION_ACTION_REMOVE_PRIMARY_CONTACT')
    : translate('RELATION_ACTION_MAKE_PRIMARY_CONTACT');

  const handleClick = async (evt) => {
    evt.preventDefault();

    try {
      setIsLoading(true);
      await updateRelationship(relation.relationshipId, {
        ...relation,
        relationData: {
          ...relation.relationData,
          primaryContact: !isPrimaryContact,
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader isCentered size={LoaderSizes.XS} />;
  }

  return (
    <Tooltip title={label}>
      <IconButton
        color="primary"
        aria-label={label}
        size="small"
        edge="start"
        onClick={handleClick}
        className={className}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}

MakeConnectionPrimaryContactButton.propTypes = {
  className: PropTypes.string,
  parent: DonorType.isRequired,
  relation: DonorRelationType.isRequired,
};

MakeConnectionPrimaryContactButton.defaultProps = {
  className: '',
};

export default MakeConnectionPrimaryContactButton;
